function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 2a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1V3a1 1 0 00-1-1H3zm9 7h-2V7.414l-3.293 3.293-1.414-1.414L8.586 6H7V4h5v5z",
  fill: "#F4F6F8"
});

var SvgNewTab = function SvgNewTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24iPgo8cGF0aCBpZD0iVmVjdG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMgMkMyLjQ0NzcyIDIgMiAyLjQ0NzcyIDIgM1YxM0MyIDEzLjU1MjMgMi40NDc3MiAxNCAzIDE0SDEzQzEzLjU1MjMgMTQgMTQgMTMuNTUyMyAxNCAxM1YzQzE0IDIuNDQ3NzIgMTMuNTUyMyAyIDEzIDJIM1pNMTIuMDAwMSA5SDEwLjAwMDFWNy40MTQyMUw2LjcwNzE4IDEwLjcwNzFMNS4yOTI5NyA5LjI5Mjg5TDguNTg1ODYgNkg3LjAwMDA4VjRIMTIuMDAwMVY5WiIgZmlsbD0iI0Y0RjZGOCIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgNewTab as ReactComponent };